export default (plan) => plan?.ticketQuantity >= 999;
